import { createFileRoute } from '@tanstack/react-router'
import { MonitorDetailView } from '@/components/monitor-detail'

export const Route = createFileRoute('/_authenticated/dashboard/monitors/$id')({
  component: MonitorDetailPage,
})

function MonitorDetailPage() {
  const { id } = Route.useParams()
  return <MonitorDetailView id={id} section="monitors" />
}
